import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    width: "100%",
  },
};

export default function EasyFlow() {
  return (
    <Box sx={styles.container}>
      <Outlet />
    </Box>
  );
}
